

import { sliceText } from "../../../utils/common";
import { safeString } from "../../../utils/logger";






export const DEPARTMENT_INITIAL_STATE={
  status:true,
  deptName:""

}
export const DEPARTMENT_INPUT_FIELDS = {

  status: {
    name: "status",
    label: "Status",
    type: "select",
    placeholder: "Type Here...",
    fullWidth: true,
    required:true,
    options:[
        { id: true, name: "Active" },
        { id: false, name: "Inactive" },
      ]
  

  },
  deptName: {
    name: "deptName",
    label: "Department Name",
    type: "text",
    placeholder: "Type Here...",
   
    fullWidth: true,
    required:true,
  
        
        
    customOptions:{
     
      formatValueFn:(value)=>{   
        
        value = sliceText((safeString(value)),150);
       return value;
     }
      
      }

  },
};


export const DEPARTMENT_API={
  DEPARTMENT_CREATE:{URL:"/department/", METHOD:"POST"},
  DEPARTMENT_UPDATE:{URL:"/department/", METHOD:"PUT"},
  DEPARTMENT_DELETE:{URL:"/department/", METHOD:"DELETE"},
  DEPARTMENT_LIST:{URL:"/department/", METHOD:"GET"},
  MASTER_DEPARTMENT_LIST:{URL:"/department/admin/master", METHOD:"GET"},
  
  };
